export const PROJECTS = [
  {
    id: 1, category: "residential",
    title: "The Obsidian Lounge", subtitle: "Residential Sanctuary · Ed. 01",
    img: "assets/re1.jpeg",
  },
  {
    id: 2, category: "residential",
    title: "The Obsidian Lounge", subtitle: "Residential Sanctuary · Ed. 01",
    img: "assets/re2.jpeg",
  },
  {
    id: 3, category: "residential",
    title: "The Obsidian Lounge", subtitle: "Residential Sanctuary · Ed. 01",
    img: "assets/re3.jpeg",
  },
  {
    id: 4, category: "residential",
    title: "The Obsidian Lounge", subtitle: "Residential Sanctuary · Ed. 01",
    img: "assets/re4.jpeg",
  },
  {
    id: 5, category: "residential",
    title: "The Obsidian Lounge", subtitle: "Residential Sanctuary · Ed. 01",
    img: "assets/re5.jpeg",
  },
  {
    id: 6, category: "residential",
    title: "The Obsidian Lounge", subtitle: "Residential Sanctuary · Ed. 01",
    img: "assets/re6.jpeg",
  },
  {
    id: 7, category: "residential",
    title: "The Obsidian Lounge", subtitle: "Residential Sanctuary · Ed. 01",
    img: "assets/re7.jpeg",
  },
  {
    id: 8, category: "residential",
    title: "The Obsidian Lounge", subtitle: "Residential Sanctuary · Ed. 01",
    img: "assets/re8.jpeg",
  },
  {
    id: 9, category: "residential",
    title: "The Obsidian Lounge", subtitle: "Residential Sanctuary · Ed. 01",
    img: "assets/re9.jpeg",
  },

  {
    id: 10, category: "residential",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/re10.jpeg",
  },
  {
    id: 11, category: "residential",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/re11.jpeg",
  },
  {
    id: 12, category: "residential",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/re12.jpeg",
  },
  {
    id: 13, category: "residential",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/re13.jpeg",
  },
  {
    id: 14, category: "residential",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/re14.jpeg",
  },
  {
    id: 15, category: "residential",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/re15.jpeg",
  },
  {
    id: 16, category: "residential",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/re16.jpeg",
  },
  
  //commercial
  {
    id: 17, category: "commercial",
    title: "Aura Corporate Hub", subtitle: "Commercial Workspace Axis · Ed. 02",
    img: "assets/co1.jpeg",
  },
  {
    id: 18, category: "commercial",
    title: "Aura Corporate Hub", subtitle: "Commercial Workspace Axis · Ed. 02",
    img: "assets/co2.jpeg",
  },
  {
    id: 19, category: "commercial",
    title: "Aura Corporate Hub", subtitle: "Commercial Workspace Axis · Ed. 02",
    img: "assets/co3.jpeg",
  },
  {
    id: 20, category: "commercial",
    title: "Aura Corporate Hub", subtitle: "Commercial Workspace Axis · Ed. 02",
    img: "assets/co4.jpeg",
  },
  {
    id: 21, category: "commercial",
    title: "Aura Corporate Hub", subtitle: "Commercial Workspace Axis · Ed. 02",
    img: "assets/co5.jpeg",
  },
  {
    id: 22, category: "commercial",
    title: "Aura Corporate Hub", subtitle: "Commercial Workspace Axis · Ed. 02",
    img: "assets/co6.jpeg",
  },
  {
    id: 23, category: "commercial",
    title: "Aura Corporate Hub", subtitle: "Commercial Workspace Axis · Ed. 02",
    img: "assets/co7.jpeg",
  },
  
//minimalist
  {
    id: 24, category: "minimalist",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/mi11.jpeg",
  },{
    id: 25, category: "minimalist",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/mi2.jpeg",
  },{
    id: 26, category: "minimalist",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/mi33.jpeg",
  },{
    id: 27, category: "minimalist",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/mi24.jpeg",
  },{
    id: 28, category: "minimalist",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/mi38.jpeg",
  },{
    id: 29, category: "minimalist",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/mi6.jpeg",
  },{
    id: 30, category: "minimalist",
    title: "The Alabaster Pavilion", subtitle: "Minimalist Retreat · Ed. 04",
    img: "assets/offi2.jpeg",
  },

];